import { render, staticRenderFns } from "./scopecenter10.vue?vue&type=template&id=375cfcee&scoped=true"
import script from "./scopecenter10.vue?vue&type=script&lang=js"
export * from "./scopecenter10.vue?vue&type=script&lang=js"
import style0 from "./scopecenter10.vue?vue&type=style&index=0&id=375cfcee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cfcee",
  null
  
)

export default component.exports